import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import WebhooksLogsTable from "../../../components/apps/webhooks/WebhooksLogsTable";
import { useNavigate, useLocation, useParams } from "react-router";

export default function WebhooksLogs() {
    const navigate = useNavigate();
    const location = useLocation();
    const { webhookId } = useParams<{ webhookId: string }>();

    // Obtendo o nome do webhook da URL (parâmetros de consulta)
    const queryParams = new URLSearchParams(location.search);
    const webhookName = queryParams.get('name') || 'Webhook';

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/webhooks`);
    };

    // Log para debug
    console.log("WebhooksLogs - ID:", webhookId, "Name:", webhookName);

    return (
        <>
            <PageMeta
                title="Sellyo - Webhooks Logs"
                description="Webhooks Logs"
            />
            <PageBreadcrumb
                pageTitle={`Eventos de: ${webhookName}`}
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    {webhookId ? (
                        <WebhooksLogsTable webhookId={webhookId} />
                    ) : (
                        <div className="p-8 text-center bg-white dark:bg-dark-800 rounded-lg shadow">
                            <div className="text-xl font-medium mb-2">Webhook não encontrado</div>
                            <p className="text-gray-500 dark:text-gray-400">
                                Não foi possível identificar o webhook.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}